import {ConfirmationDialog} from "./ConfirmationDialog/ConfirmationDialog";
import * as React from "react";
import {WpAjaxPost} from "shared/core/ajax/WPAjaxPost";
import {ReactNode} from "react";

export class DeleteDialog{
    public static async Show(itemName:string,title:string='Are you sure?',applyCallBack:()=>Promise<boolean>=null,content:ReactNode=null){
        return new Promise(resolve=>{
            let dialog=ConfirmationDialog.Create(title,
                content!=null?content:
                <React.Fragment>
                                <p>Are you sure you want to delete {itemName!=''?<strong
                            style={{color: 'red'}}>{itemName}</strong>:'this item'}?</p>
                        </React.Fragment>)
                            .UseDeleteIcon()
                .SetApplyText('Yes, delete');

            if(applyCallBack!=null) {
                dialog.OnApply(applyCallBack);
                dialog.Show();
            }else{
                resolve(dialog.Show());
            }



        });
    }
}